<template>
  <v-row justify="center">
    <v-dialog v-model="visible" persistent width="1000px" scrollable>
      <v-form ref="form" @submit.prevent="handleSubmit">
        <v-card height="800">
          <v-card-title>{{ $t("modal.csvSearch.title") }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="5" align="right">
                <v-file-input
                  dense
                  accept=".csv"
                  :label="$t('modal.csvSearch.label.upload')"
                  v-model="csvFile"
                  v-on:click:clear="onClearSelected"
                ></v-file-input>

                <v-btn small dark v-on:click="onFileSelected" color="green">
                  Read CSV
                  <v-icon right dark>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="7">
                <v-expansion-panels v-model="openedPanel">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="title">
                      {{ $t("modal.csvSearch.label.csvOptions") }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Configure header mappings and file delimiter.
                      <br />
                      Date format: YYYY-MM-DD
                      <v-container>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              :label="$t('label.searchColName')"
                              v-model="nameColumnName"
                              dense
                              clearable
                            />
                          </v-col>
                          <v-col cols="6">
                            <v-select
                              :items="delimeters"
                              :label="$t('label.delimiter')"
                              v-model="delimiter"
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              :label="$t('label.dobColName')"
                              v-model="dobColumnName"
                              dense
                              clearable
                            />
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              :label="$t('label.citizenshipColName')"
                              v-model="citizenshipColumnName"
                              dense
                              clearable
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <!-- <v-col cols="6">
                            <v-text-field
                              :label="$t('label.ssnColName')"
                              v-model="ssnColumnName"
                              dense
                              clearable
                            />
                          </v-col> -->
                          <v-col cols="6">
                            <v-text-field
                              :label="$t('label.einColName')"
                              v-model="einColumnName"
                              dense
                              clearable
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              :label="$t('label.licenseNumberColName')"
                              v-model="licenseNumberColName"
                              dense
                              clearable
                            />
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              :label="$t('label.licenseCountryColName')"
                              v-model="licenseCountryColName"
                              dense
                              clearable
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              :label="$t('label.localIdColName')"
                              v-model="localIdColName"
                              dense
                              clearable
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-data-table
                  :loading="csvTableLoading"
                  :headers="headers"
                  :items="searchBatch"
                  :no-data-text="tableText"
                  dense
                  :items-per-page="10"
                >
                  <template v-slot:item.dob="{ item }">
                    <span v-if="item.dobInvalid" class="red--text"
                      >Invalid Format</span
                    >
                    <span v-else-if="item.dob">{{ item.dob }}</span>
                  </template>
                  <template v-slot:item.actions="prop">
                    <v-btn
                      text
                      x-small
                      color="red"
                      @click="onDeleteClick(prop.item.name)"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:item.addressIncluded="{ item }">
                    <v-icon v-if="item.addressIncluded" small>mdi-check</v-icon>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="onCancel">{{
              $t("label.cancel")
            }}</v-btn>
            <v-btn
              color="blue darken-1"
              type="submit"
              :disabled="searchBatch.length < 1"
            >
              {{ $t("label.search") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import Papa from "papaparse";
export default {
  name: "CSVSearch",
  data() {
    return {
      csvTableLoading: false,
      csvFile: null,
      csvFileName: null,
      fileData: null,
      searchBatch: [],
      nameColumnName: "name",
      dobColumnName: "dob",
      citizenshipColumnName: "citizenship",
      // ssnColumnName: "ssn",
      einColumnName: "ein",
      licenseNumberColName: "licenseNumber",
      licenseCountryColName: "licenseCountry",
      localIdColName: "id",
      delimiter: ",",
      tableText: "Upload CSV search names",
      openedPanel: [],
      rules: {
        required: (value) => !!value || "Required.",
      },
      headers: [
        { text: "Search Name", value: "name" },
        { text: "Date of Birth", value: "dob" },
        { text: "Citizenship", value: "citizenship" },
        // { text: "SSN", value: "ssn" },
        { text: "EIN", value: "ein" },
        { text: "ID", value: "localId" },
        { text: "Address", value: "addressIncluded" },
        { text: "Actions", value: "actions", sortable: false, align: "right" },
      ],
      delimeters: [
        { text: "Comma ( , )", value: "," },
        { text: "Pipe ( | ) ", value: "|" },
      ],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClearSelected() {
      this.tableText = "Upload CSV search names";
      this.searchBatch = [];
    },
    isValidDate(dateString) {
      // expects date format yyyy-MM-dd, ISO_LOCAL_DATE
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
    onFileSelected() {
      if (!this.csvFile) {
        return false;
      }

      this.openedPanel = [];

      this.csvTableLoading = true;

      this.csvFileName = this.csvFile.name;
      try {
        Papa.parse(this.csvFile, {
          header: true,
          skipEmptyLines: true,
          delimiter: this.delimiter,
          complete: function (result) {
            if (result.errors.length > 0) {
              console.log(result.errors);
              this.tableText =
                "Error uploading CSV data, please check your delimiter and data headers.";
              return;
            }

            // create new array with using name header

            if (!this.nameColumnName) this.nameColumnName = "name";

            var formattedArray = result.data.reduce((filtered, record) => {
              var searchCase = {};

              if (
                Object.prototype.hasOwnProperty.call(
                  record,
                  this.nameColumnName
                )
              ) {
                // If the name column is empty, the record is removed from the batch
                if (!record[this.nameColumnName]) {
                  return filtered;
                }
                searchCase.name = record[this.nameColumnName];
              }

              if (this.dobColumnName) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    record,
                    this.dobColumnName
                  )
                ) {
                  if (record[this.dobColumnName]) {
                    if (!this.isValidDate(record[this.dobColumnName])) {
                      searchCase.dobInvalid = true;
                    } else {
                      searchCase.dob = record[this.dobColumnName];
                    }
                  }
                }
              }

              if (this.citizenshipColumnName) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    record,
                    this.citizenshipColumnName
                  )
                ) {
                  if (record[this.citizenshipColumnName]) {
                    searchCase.citizenship = record[this.citizenshipColumnName];
                  }
                }
              }

              // if (this.ssnColumnName) {
              //   if (
              //     Object.prototype.hasOwnProperty.call(
              //       record,
              //       this.ssnColumnName
              //     )
              //   ) {
              //     if (record[this.ssnColumnName]) {
              //       searchCase.ssn = record[this.ssnColumnName];
              //     }
              //   }
              // }

              if (this.einColumnName) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    record,
                    this.einColumnName
                  )
                ) {
                  if (record[this.einColumnName]) {
                    searchCase.ein = record[this.einColumnName];
                  }
                }
              }

              if (this.localIdColName) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    record,
                    this.localIdColName
                  )
                ) {
                  if (record[this.localIdColName]) {
                    searchCase.localId = record[this.localIdColName];
                  }
                }
              }

              /**
               * Drivers license must at least include the license number
               */
              if (this.licenseNumberColName) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    record,
                    this.licenseNumberColName
                  )
                ) {
                  if (record[this.licenseNumberColName]) {
                    var driversLicense = {};
                    driversLicense.licenseNumber =
                      record[this.licenseNumberColName];
                    if (record[this.licenseCountryColName]) {
                      driversLicense.licenseCountry =
                        record[this.licenseCountryColName];
                    }
                    searchCase.driversLicense = driversLicense;
                  }
                }
              }

              // Address
              if (
                record["address1"] ||
                record["address2"] ||
                // record["address3"] ||
                // record["address4"] ||
                record["city"] ||
                record["stateOrProvince"] ||
                record["postalCode"] ||
                record["country"]
              ) {
                var address = {
                  address1: record["address1"],
                  address2: record["address2"],
                  city: record["city"],
                  stateOrProvince: record["stateOrProvince"],
                  postalCode: record["postalCode"],
                  country: record["country"],
                };
                searchCase.address = address;
                searchCase.addressIncluded = true;
              }

              filtered.push(searchCase);
              return filtered;
            }, []);

            if (formattedArray.length < 1) {
              this.tableText =
                "Unable to parse tabular data, please check your delimiter and data headers.";
              return;
            }

            // remove duplicates
            const seen = new Set();
            const dedupedCases = formattedArray.filter((el) => {
              const duplicate = seen.has(el.name);
              seen.add(el.name);
              return !duplicate;
            });

            this.searchBatch = dedupedCases;
          }.bind(this),
        });
      } catch (e) {
        console.log(e);
      }

      this.csvTableLoading = false;
    },
    handleSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      var request = {};

      // request.batch = this.searchBatch.map(function (item) {
      //   return { name: item.name, dob: item.dob, citizenship: item.citizenship } // TODO is this needed or is collection already correct?
      // })

      request.batch = this.searchBatch;

      request.fileName = this.csvFileName;

      this.$emit("onConfirmed", request);
    },
    onDeleteClick(name) {
      this.searchBatch = this.searchBatch.filter(function (obj) {
        return obj.name !== name;
      });
    },
    onCancel() {
      this.$emit("onCancelled");
    },
  },
};
</script>